import React from "react";
import styled from "styled-components";
import { Wrap } from "./games";
import { ContactFooter, PageHeader, LargeTitle, Subtitle } from "../ui";
import { BentoGrid } from "../Bento";

// Apple Store "bento": one feature card spanning two rows + a 2×2 block of product cards.
const ITEMS = [
  {
    // /1 is a static page (public/1/index.html), outside the React router
    key: "deck", href: "/1", feature: true, eyebrow: "מצגת", title: "מצגת קורס אמנות", desc: "כיתות א׳–ה׳, שיעור אחר שיעור", emoji: "🖌️",
    tint: "#7c3aed", wash: "linear-gradient(160deg, #f3eaff 0%, #fde8f1 55%, #ffeede 100%)",
  },
  {
    key: "gear", to: "/sigal/gear", eyebrow: "רשימה", title: "רשימת ציוד", desc: "כל מה שצריך לשיעור", emoji: "🎨",
    tint: "#db2777", wash: "linear-gradient(160deg, #ffe9f2, #fff3e6)",
  },
  {
    key: "plan", to: "/sigal/art-lesson-plan", eyebrow: "תכנון", title: "מערך שנתי", desc: "תוכנית השיעורים השנתית", emoji: "📅",
    tint: "#0f766e", wash: "linear-gradient(160deg, #e3f7f2, #e8f1ff)",
  },
  {
    key: "schedule", to: "/schedule", eyebrow: "אפליקציה", title: "מערכת שעות", desc: "כל השבוע במבט אחד", emoji: "🗓️",
    tint: "#bf4800", wash: "linear-gradient(160deg, #f6fbdc, #eaf1ff)",
  },
  {
    key: "hours", to: "/sigal/hours", eyebrow: "אפליקציה", title: "שעות נוספות", desc: "מעקב אחרי שעות נוספות", emoji: "⏱️",
    tint: "#bf4800", wash: "linear-gradient(160deg, #e8f3ff, #f1ecff)",
  },
];

export const SigalSchool = () => (
  <div className="page page-games">
    <Wrap>
      <PageHeader>
        <LargeTitle>סיגל בית ספר</LargeTitle>
        <Subtitle>כלים לשיעורי האמנות: מצגות, ציוד, תכנון ושעות</Subtitle>
      </PageHeader>
      <BentoGrid items={ITEMS.map((it) => ({ ...it, art: <Emoji>{it.emoji}</Emoji> }))} />
      <ContactFooter />
    </Wrap>
  </div>
);

const Emoji = styled.span`
  font-size: 100px;
  line-height: 1;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.16));
`;
